import { useState } from "react";
import { useNavigate } from "react-router-dom";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";

import KeyIcon from "@mui/icons-material/Key";
import EmailIcon from "@mui/icons-material/Email";
import LoginIcon from "@mui/icons-material/Login";

import axios from "axios";
import { toast } from "react-toastify";

import useAuth from "../../hooks/useAuth";

import Logo from "../../assets/nba_logo.png";


function AdminLoginForm() {

  const navigate = useNavigate();

  const {
    setIsAuthenticated,
  } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // const [errorMsg, setErrorMsg] = useState("");

  const [isLoading, setIsLoading] = useState(false);


  const handleLoginSubmit = async (e) => {

    e.preventDefault();

    // ===============================
    // Validation
    // ===============================

    if (!email.trim()) {

      toast.error("Please enter your email");

      return;
    }

    if (!password.trim()) {

      toast.error("Please enter your password");

      return;
    }


    setIsLoading(true);
    // setErrorMsg("");


    try {

      const response = await axios.post(
        "https://badmintonnepal.org/api/admin/login",
        // "http://localhost:8006/api/admin/login",
        {
          email: email.trim(),
          password,
        },
        {
          withCredentials: true,
        }
      );


      console.log("Login Response:", response);


      if (response.status === 200) {

        // Update authentication state
        setIsAuthenticated(true);


        toast.success(
          response.data?.message ||
          "Login Success",
          {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          }
        );


        navigate(
          "/register",
          {
            replace: true,
          }
        );
      }


    } catch (err) {

      console.error(
        "Login Error:",
        err
      );


      const message =
        err.response?.data?.message ||
        err.message ||
        "Unable to login";


      // setErrorMsg(message);


      toast.error(
        `${message}`,
        {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        }
      );

    } finally {

      setIsLoading(false);

    }
  };


  return (

    <Box
      sx={{
        position: "relative",
      }}
    >

      {/* ================================= */}
      {/* Loading Overlay */}
      {/* ================================= */}

      {isLoading && (

        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(7, 7, 7, 0.04)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >

          <CircularProgress />

        </Box>

      )}


      {/* ================================= */}
      {/* Login Form */}
      {/* ================================= */}

      <form
        onSubmit={handleLoginSubmit}
      >

        {/* ================================= */}
        {/* Logo + Title */}
        {/* ================================= */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            mb: 3,
          }}
        >

          <Box
            sx={{
              height: "40px",
              width: "46px",

              backgroundImage: `url(${Logo})`,
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />

          <Typography
            sx={{
              color: "#000000",
              textAlign: "center",
              fontSize: {
                xs: "14px",
                sm: "18px",
              },
              fontFamily: "Roboto-serif",
              fontWeight: 540,
            }}
          >
            Nepal Badminton Association(NBA)
          </Typography>

        </Box>


        {/* ================================= */}
        {/* Fields */}
        {/* ================================= */}

        <Box
          display="flex"
          flexDirection="column"
          gap="1rem"
          justifyContent="center"
        >

          {/* Email */}

          <TextField
            label="Email"
            type="email"
            variant="standard"
            value={email}
            onChange={(e) =>
              setEmail(e.target.value)
            }
            autoComplete="email"
            disabled={isLoading}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
          />


          {/* Password */}

          <TextField
            label="Password"
            type="password"
            variant="standard"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
            autoComplete="current-password"
            disabled={isLoading}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <KeyIcon />
                </InputAdornment>
              ),
            }}
          />

          {/* Login Button */}

          <Button
            type="submit"
            variant="contained"
            disabled={isLoading}
            endIcon={
              <LoginIcon />
            }
            sx={{
              width: "100px",
              alignSelf: "center",
              backgroundColor: "#022362",

              "&:hover": {
                backgroundColor: "#011947",
              },
            }}
          >

            Login

          </Button>
        </Box>

      </form>

    </Box>
  );
}

export default AdminLoginForm;